type DateOptionValue<T> = {
  add(duration: { days: number }): T
  compare(other: T): number
  toString(): string
}

export function getDeliveryDateOptions<T extends DateOptionValue<T>>(
  startDate: T,
  days: number,
  blockedDates: Set<string>,
  maximumDate?: T,
): T[] {
  const candidateCount = days + blockedDates.size
  return Array.from(
    { length: candidateCount },
    (_, index) => startDate.add({ days: index }),
  )
    .filter(day => !blockedDates.has(day.toString()))
    .filter(day => maximumDate === undefined || day.compare(maximumDate) <= 0)
    .slice(0, days)
}
